import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ForecastService {

  constructor(private http: HttpClient) {

  }

  /**
   *
   * @param param
   * @returns
   */
  saveForecast(param: any) {
    return this.http.post(`${environment.api_cm_manualtimesheet}/saveForecast`, param )
      .pipe(map(data => data));
  }

  /**
   *
   * @param param
   * @returns
   */
  getListForecast(param: any) {
    let params = new HttpParams();
    if (param.filter != null && param.filter?.length > 0) {
      params = params.append('filter', param.filter);
    }
    params = params.append('page', param.pageIndex);
    params = params.append('page_size', param.pageSize);
    return this.http.get(`${environment.api_cm_manualtimesheet}/listForecast`, { params: params })
      .pipe(map(data => data));
  }

}
